/**
 * The client that owns every system-wide record (workflow definitions, AVVs, system e-mail
 * settings). Mirrors `SeedingClient.Id` in `Lib/Framework/Constants/SeedingClient.cs`.
 */
export const SEEDING_CLIENT_ID = '10000000-0000-0000-0000-000000000000';
